import React from "react";

/**
 * SeasonGrid — season_shape evidence component.
 *
 * 12 cells, one per month, coloured by campable_day_pct.
 * Each shows month name, typical high/low, and campable percentage.
 * Caption: "Campable means highs 55–95°F, lows above freezing,
 * and rain in fewer than half of past years."
 *
 * Spec references: §7 (season_shape).
 */

const MONTH_NAMES = [
  "", "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

/** Colour based on campable_day_pct. */
const campableColor = (pct) => {
  if (pct >= 80) return "bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400";
  if (pct >= 60) return "bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400";
  if (pct >= 40) return "bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400";
  if (pct >= 20) return "bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-400";
  return "bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400";
};

const SeasonGrid = ({ panel }) => {
  const f = panel.facts || {};
  const months = f.months || [];

  if (months.length === 0) return null;

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-2">
        {months.map((m) => {
          const name = MONTH_NAMES[m.month] || `Month ${m.month}`;
          const campable = m.campable_day_pct ?? 0;
          const colorClass = campableColor(campable);

          return (
            <div key={m.month} className={`rounded-lg p-2 text-center ${colorClass}`}>
              <p className="text-xs font-semibold uppercase tracking-wider opacity-70">
                {name.slice(0, 3)}
              </p>
              <p className="text-xl font-bold leading-none mt-0.5">
                {campable}%
              </p>
              <p className="text-xs opacity-70 mt-0.5">
                {m.typical_high_f != null ? `${m.typical_high_f}°` : "—"}/{m.typical_low_f != null ? `${m.typical_low_f}°` : "—"}
              </p>
              {m.rain_day_pct > 0 && (
                <p className="text-xs opacity-60">
                  Rain {m.rain_day_pct}%
                </p>
              )}
            </div>
          );
        })}
      </div>

      {/* Caption */}
      <p className="text-xs text-center text-gray-400 dark:text-gray-500">
        Campable means highs 55–95°F, lows above freezing, and rain in fewer than half of past years.
      </p>
    </div>
  );
};

export default SeasonGrid;
